import { autoinject } from "aurelia-framework";
import { MeasuresAdminService, IMeasureVM, MeasureVM } from "../measures-admin-service";
import { ResourcedNotificationService, NotificationType } from "../../../../components/notifications/notification-service";
import { IValidationErrorsAM } from "../../../../utils/validation";
import { Router } from "aurelia-router";

interface IMeasureEditParams {
	measureId: string;
}

@autoinject
export class MeasureEdit {
	measure: MeasureVM;
	languages: string[];
	validationErrors: IValidationErrorsAM = null;

	constructor(private service: MeasuresAdminService, private notif: ResourcedNotificationService, private router: Router) {}

	async activate(urlParams: IMeasureEditParams) {
		const measure = await this.service.getMeasure(urlParams.measureId);
		this.measure = new MeasureVM(measure);
		this.languages = Object.keys(this.measure.name);
	}

	async updateMeasure(measure: IMeasureVM) {
		this.validationErrors = null;
		
		const response = await this.service.updateMeasure(measure);

		if(response.ok) {
			this.notif.push('ViewMessage_SaveSucceeded', NotificationType.Success);
		} else {
			this.validationErrors = await response.json();
		}
	}

	async deleteMeasure(measure: IMeasureVM) {
		const response = await this.service.deleteMeasure(measure);

		if(response.ok) {
			this.router.navigateToRoute('measures-list');
		} else {
			this.validationErrors = await response.json();
		}
	}
}
